import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Tooltip } from 'antd';

interface WrappingEllipseInterface {
	message: string;
	maxLength: number | string;
	maxLines?: number; // Number of lines before truncating
	isTooltip?: boolean;
	tooltipMessage?: string;
}

const WrappingEllipse = (props: WrappingEllipseInterface) => {
	const {
		message,
		isTooltip,
		tooltipMessage,
		maxLength = 10,
		maxLines = 2,
	} = props;
	const [truncatedText, setTruncatedText] = useState(message);
	const [shouldTruncate, setShouldTruncate] = useState(false);
	const textRef = useRef<any>(null);

	useEffect(() => {
		const handleTruncation = () => {
			const maxLen =
				typeof maxLength === 'string' ? parseInt(maxLength, 10) : maxLength;
			if (message.length > maxLen) {
				const truncated = message.substring(0, maxLen) + '...';
				setTruncatedText(truncated);
				setShouldTruncate(true);
			} else {
				setTruncatedText(message);
				setShouldTruncate(false);
			}
		};

		handleTruncation();
	}, [message, maxLength]);

	return (
		<div
			className={styles['wrapping-ellipse-container']}
			ref={textRef}
			style={{
				WebkitLineClamp: maxLines,
			}}
		>
			{isTooltip && shouldTruncate ? (
				<Tooltip title={tooltipMessage || message}>{truncatedText}</Tooltip>
			) : (
				truncatedText
			)}
		</div>
	);
};

export default WrappingEllipse;
